import { Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";
import { Input } from "../../../../components/common/input";
import { Chip } from "../../../../components/common/chip";

const REJECTION_REASONS = [
  "Document expired",
  "Illegible scan",
  "Wrong document uploaded",
  "Information mismatch",
];

interface RejectFormProps {
  selectedReason: string | null;
  onSelectReason: (reason: string | null) => void;
  notes: string;
  onNotesChange: (value: string) => void;
  isSubmitting: boolean;
  onReject: () => void;
  onCancel: () => void;
}

export function RejectForm({
  selectedReason,
  onSelectReason,
  notes,
  onNotesChange,
  isSubmitting,
  onReject,
  onCancel,
}: RejectFormProps) {
  return (
    <>
      <div className="flex flex-col gap-2">
        <Text variant="bodySmBold" tone="dark">Reason for rejection</Text>
        <div className="flex flex-wrap gap-2">
          {REJECTION_REASONS.map((reason) => (
            <Chip
              key={reason}
              variant="primary"
              selected={selectedReason === reason}
              onClick={() => onSelectReason(selectedReason === reason ? null : reason)}
            >
              {reason}
            </Chip>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <Input
          name="notes"
          label="Additional notes (optional)"
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="e.g. The scan is too blurry to verify the CR number…"
          multiline
          rows={3}
        />
        <Text variant="bodySm" tone="muted">
          The buyer will be notified with this reason by email.
        </Text>
      </div>

      <div className="flex gap-3">
        <Button
          variant="secondaryDanger"
          size="md"
          onClick={onReject}
          disabled={isSubmitting || !selectedReason}
        >
          {isSubmitting ? "Rejecting…" : "Confirm Rejection"}
        </Button>
        <Button
          variant="secondary"
          size="md"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </div>
    </>
  );
}
